import React, { useMemo } from 'react';
import { TransportService } from 'service/TransportService';
import { TRANSPORT } from 'helpers/routes';
import ExchangeTransportSearch from 'models/exchangeTransportSearch';
import SearchTabs, { SearchTabsConfig, SearchTabsProps } from 'components/common/SearchTabs';

export { NEW_TEMPLATE_ID } from 'components/common/SearchTabs';

type TransportSearchTabsProps = Omit<SearchTabsProps, 'config'>;

const TransportSearchTabs: React.FC<TransportSearchTabsProps> = (props) => {
  const config: SearchTabsConfig = useMemo(() => ({
    fetchTemplates: TransportService.getExchangePatterns,
    deleteTemplate: TransportService.deleteExchangePattern,
    updateTemplate: TransportService.updateExchangePattern,
    getTemplate: TransportService.getExchangePattern,
    prepareUpdateData: (template) => ExchangeTransportSearch.templateData(ExchangeTransportSearch.formData(template)),
    translationPrefix: 'transportSearch',
    mapRoute: TRANSPORT.map,
  }), []);

  return <SearchTabs config={config} {...props} />;
};

export default TransportSearchTabs;
